<h1>{{ this.currentTitle }}</h1>

<div [nbSpinner]="loading"
     nbSpinnerStatus="danger"
     nbSpinnerSize="large"
     nbSpinnerMessage="">

  <app-division-selector [divisions]="divisions()" [selectedDivisionId]="selectedDivisionId" (divisionChanged)="onDivisionChange($event)"></app-division-selector>

  <app-group-selector class="mt-20" [style.visibility]="displayGroupFilter() ? 'visible' : 'hidden'" [groups]="groups" [selectedGroupId]="selectedGroupIdSignal()" (groupChanged)="onGroupChange($event)"></app-group-selector>

  <nb-tabset #tabset (changeTab)="onTabChange($event)">
    @if (showPrivateTabs()) {
      <nb-tab [tabTitle]="'games.tabs.organize' | translate" tabId="organize">
        <app-organize [selectedDivisionName]="selectedDivisionName"
                      [selectedGroupName]="selectedGroupName"
                      [selectedDivisionIdSignal]="selectedDivisionIdSignal"
                      [selectedGroupIdSignal]="selectedGroupIdSignal"
                      (onMatchUpdate)="onMatchUpdate('by_organize')"></app-organize>
      </nb-tab>
    }

    @if (showPrivateTabs()) {
      <nb-tab [tabTitle]="'games.tabs.planning' | translate"
              [badgeText]="nbNotifications()"
              badgePosition="center end"
              badgeStatus="danger" tabId="planning">
        <app-planning
          [triggerTabsRefresh]="refreshTabs"
          [currentUserTeamIds]="currentUserTeamIds"
          (onMatchUpdate)="onMatchUpdate('by_planning')"
          (nbNotificationsChanged)="onNbNotificationsChange($event)"></app-planning>
      </nb-tab>
    }

    <nb-tab [tabTitle]="'games.tabs.scheduled' | translate" tabId="scheduled">
      <app-scheduled
        [triggerTabsRefresh]="refreshTabs"
        [currentUserTeamIds]="currentUserTeamIds"
        [selectedDivisionIdSignal]="selectedDivisionIdSignal"
        [selectedGroupIdSignal]="selectedGroupIdSignal"></app-scheduled>
    </nb-tab>

    @if (showPrivateTabs()) {
      <nb-tab [tabTitle]="'games.tabs.report' | translate" tabId="report-game">
        <app-report
          [triggerTabsRefresh]="refreshTabs"
          [currentUserTeamIds]="currentUserTeamIds"
          [selectedDivisionIdSignal]="selectedDivisionIdSignal"
          [selectedGroupIdSignal]="selectedGroupIdSignal"
          (onMatchUpdate)="onMatchUpdate('by_report')"></app-report>
      </nb-tab>
    }

    <nb-tab [tabTitle]="'games.tabs.played' | translate" tabId="played">
      <app-played
        [triggerTabsRefresh]="refreshTabs"
        [selectedDivisionIdSignal]="selectedDivisionIdSignal"
        [selectedGroupIdSignal]="selectedGroupIdSignal"></app-played>
    </nb-tab>
  </nb-tabset>
</div>
